module.exports = __webpack_public_path__ + "img/empty.bdc879d8.png";